<template>
  <!-- 选择保险公司 -->
  <div class="bank">
    <div class="title">请选择保险公司</div>
    <el-radio-group v-model="radio" class="radio-group">
      <el-radio :label="item.identification" v-for="item in companyArr" :key="item.identification" class="radio" border>
        <div class="bank_info">
          <div style="width: 171px; height: 103px">
            <img :src="item.logoUrl" alt style="height: 100%; width: 100%" />
          </div>
          <div style="font-size: 16px; color: #333; flex: 1">
            <div style="margin-top: 20px; margin-left: 10px">
              {{item.guarantorName}}
            </div>
            <div style="margin-top: 5px; margin-left: 10px">
              <span>费率：</span>
              <span style="color: #fe0809">{{item.rate*10000}}‱、最低{{ item.inZhiLowerFee }}元</span>
            </div>
          </div>
        </div>
      </el-radio>
      <!-- <el-radio label="1" class="radio" border  v-if="formList.province=='河北省'">
        <div class="bank_info">
          <div style="width: 171px; height: 103px">
            <img src="../assets/品牌简横板.jpg" alt style="height: 100%; width: 100%" />
          </div>
          <div style="font-size: 16px; color: #333; flex: 1">
            <div style="margin-top: 20px; margin-left: 10px">
              安诚财产保险股份有限公司
            </div>
            <div style="margin-top: 5px; margin-left: 10px">
              <span>费率：</span>
              <span style="color: #fe0809">8‱、最低150元</span>
            </div>
          </div>
        </div>
      </el-radio> -->
    </el-radio-group>
    <div class="footer">
      <el-button type="primary" @click="payment"> 下一步 </el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" @close="close" append-to-body width="60%">
      <div>
        <div style="background-color: #f7f8fc; padding: 20px 25px;height: 50vh;overflow: auto;">
          <!-- 条款 -->
          <clause :clauseIndex="clauseIndex" :radio="radio"></clause>
        </div>
        <div style="margin: 20px 0; display: flex; justify-content: center;" >
          <el-button type="primary" size="small" @click="clause(1)">《投保须知》</el-button>
          <el-button style="margin-left: 20px;" type="primary" size="small" @click="clause(2)">《保险条款》</el-button>
          <el-button style="margin-left: 20px;" type="primary" size="small" @click="clause(3)">《特别约定》</el-button>
          <el-button style="margin-left: 20px;" v-show="radio == '1'" type="primary" size="small" @click="clause(4)">《隐私政策》</el-button>
          <el-button style="margin-left: 20px;" v-show="radio == '2'" type="primary" size="small" @click="clause(4)">《投保声明》</el-button>
        </div>
      </div>
      <div style="text-align: center; margin-top: 20px">
        <el-checkbox v-model="checked1"> 已阅读并知晓以上条款信息 </el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="text-align: center">
          <el-button type="info" @click="dialogVisible = false">关 闭</el-button>
          <el-button type="primary" @click="inform">确 定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { makeOrder, MakeOrderController ,insuranceList} from "../apis/project/index";
import Clause from "./components/clause.vue";
export default {
  components: {Clause},
  data() {
    return {
      checked1: false,
      isShow: false,
      comCode: 1,
      type: null,
      previous: null,
      form: null,
      radio: "2",
      dialogVisible: false,
      clauseIndex: 1,//阅读条款
      companyArr:[],//所有公司
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log(from); // 上一页面的路由信息
      if (from) {
        vm.previous = from.name;
        console.log("this.previous", vm.previous);
      } else {
      }
    });
  },
  props: {
    formList: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.form = this.formList;
    this.type = 2;
    window.sessionStorage.setItem("type", "2");
    this.compeny();
    // if (this.previous == "selfHelp") {
    //   console.log(this.$route.params);
    //   this.form = this.$route.params.key;
    //   this.type = 2;
    //   window.sessionStorage.setItem("type", "2");
    // } else if (this.previous == "agreement") {
    //   this.form = this.$route.params.key;
    //   this.form.userId = Number(window.sessionStorage.getItem("userId"));
    //   this.form.manageId = Number(window.sessionStorage.getItem("manageId"));
    //   this.type = 1;
    //   window.sessionStorage.setItem("type", "1");
    // }
  },
  methods: {
    // 获取保险公司
    compeny() { 
      insuranceList({
        pageSize: 1000,
        pageNumber: 1,
        fcid:'CANG_ZHOU_AN_CHENG',
      }).then((res) => {
        this.companyArr = res.data.data.records.filter(item => {
          // 如果为河北省以外的地区则不能选择安诚保险公司
          console.log(this.formList.province)
          if (this.formList.province != '河北省') {
            return item.identification == '2'
          }
          else {
            return item
          }
        }).reverse();
        this.companyArr.map(itemUrl => {
          itemUrl.logoUrl = `api/OrderListController/viewLogo/${itemUrl.guarantorId}`
          return itemUrl
        })
      });
    },
    clause(e) {
      this.clauseIndex = e
    },
    china() {
      if (this.radio == '2') {
        this.comCode = "3";
      }
      this.form.guarantorId = this.comCode;
      this.form.insuranceCompanyName = this.radio;
      this.form.businessType = 1;
      this.form.accessDevice='PC'
    },
    payment() {
      if (!this.checked1) {
        // this.$alert(
        //   "<strong>请先阅读并同意授权书 <br />涉及到您公司的利益，请认证阅读，并确认！</strong>",
        //   "警告提示",
        //   {
        //     confirmButtonText: "确定",
        //     type: "warning",
        //     dangerouslyUseHTMLString: true,
        //   }
        // );
        // this.dialogVisible = true;
        this.dialogVisible = true;
      } else {
        this.china()
        if (this.type == 2) {
          makeOrder(this.form).then((res) => {
            if (res.data.status > 0) {
              window.sessionStorage.setItem("orderFee", res.data.data.orderFee);
              window.sessionStorage.setItem("orderId", res.data.data.orderId);
              window.sessionStorage.setItem("comCode", this.comCode);
              //选择公司1为安城2为大家财
              window.sessionStorage.setItem("insuranceCompanyName", this.radio);
              // this.$router.push({
              //   name: "pay",
              // });
              this.$emit("step", 3);
            }
          });
        } else {
          MakeOrderController(this.form).then((res) => {
            if (res.data.status > 0) {
              window.sessionStorage.setItem("orderFee", res.data.data.orderFee);
              window.sessionStorage.setItem("orderId", res.data.data.id);
              window.sessionStorage.setItem("comCode", this.comCode);
              // this.$router.push({
              //   name: "pay",
              // });
              this.$emit("step", 3);
            }
          });
        }
      }
    },
    inform() {
      if (!this.checked1) {
        this.$alert(
          "<strong>请先阅读并同意授权书 <br />涉及到您公司的利益，请认证阅读，并确认！</strong>",
          "警告提示",
          {
            confirmButtonText: "确定",
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        );
      }
      else {
        this.dialogVisible = false
        this.payment()
      }
    },
    close() { 
      this.checked1=false
    }
  },
};
</script>

<style lang="less" scoped>
.selete {
  border: 1px solid #777777;
  flex: 1;
  cursor: pointer;
}

.radio-group {
  display: flex;
}

.bank {
  background: #ffffff;
  padding: 15px 35px;

  .radio {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .bank_info {
      display: flex;
      justify-content: space-between;
      // border: 1px solid #000000;
      padding: 0 10px;
    }
  }

  .footer {
    margin-top: 50px;
    text-align: end;
  }
}

::v-deep .selete .el-card__body {
  padding: 0;
  display: flex;
}

::v-deep .el-radio.is-bordered {
  height: 100%;
}</style>
